import React from 'react';
import bem from '../../utils/bem';
import './Badge.scss';

const Badge = ({ message, noParentAbsolute, left }) => {
  return (
    <div className={bem('veinsa-badge', {
      'no-absolute': noParentAbsolute,
      left
    })}>
      <span>{message}</span>
    </div>
  )
};

export default Badge;